
export const OPERATORS = {
  EQUALTO: 'EqualTo',
  GREATERTHANEQUALTO: 'GreaterThanEqualTo',
  GREATERTHAN: 'GreaterThan',
  LESSTHANEQUALTO: 'LessThanEqualTo',
  LIKE: 'Like',
  LESSTHAN: 'LessThan',
  NOTEQUALTO: 'NotEqualTo',
  NOTLIKE: 'NotLike',
  SAMEAS: 'SameAs'
};

export const DISTPERIODS = {
  QUARTER: 'qtr',
  MONTH: 'mon',
  YEAR: 'fye',
  PROJECTED: 'proj'
};

export const FIELDS = {
  TCWSODISSUE: 'TCWSODIssue',
  TCTICKER: 'TCTicker',
  TCDERIVEDTICKER: 'TCDerivedTicker',
  TCTIAACREFID: 'TCTIAACrefID',
  TCTIAACUSIP: 'TCTIAACUSIP',
  TCFUNDSHARECLASSID: 'TCFundShareClassID',
  TCINVESTMENTNAME: 'TCInvestmentName',
  TCFUNDTYPE: 'TCFundType',
  TCSHARECLASS: 'TCShareClass',
  MSTARRATINGOVERALL: 'TCMstarRatingOverall',
  MSTARRATINGOVERALLNULL: 'TCMStarRatingOverallNonNull',
  PERFORMANCEFILTER: 'TCBestReturn3YrPtileRank',
  PERFVSPEERSFILTER: 'TCPerformanceRatingOverall',
  RISKFILTER: 'TCBestStdDevPtileRank',
  EXPENSEFILTER: 'TCNetExpensesFilterPtileRank',
  RISKVSPEERS: 'TCRiskRatingOverall',
  YIELDFILTER: 'TCBestYieldPtileRank',
  DAILYYTDFILTER: 'TCFundNavYTDPctChangePtileRank',
  MSTARBONDBOXFILTER: 'TCMstarStyleBoxBond',
  MSTAREQUITYBOXFILTER: 'TCMstarStyleBoxEquity',
  TCNETEXPENSESFILTERPTILETANK: 'TCNetExpensesFilterPtileRank',
  ACTIVEDATE: 'TCActiveDate',
  ASSETCLASS: 'TCAssetClass',
  PRODUCTTYPE: 'TCProduct',
  NETEXPENSERATIO: 'TCATANetExpenseRatio',
  TCMNYMKTAVGANNUALYIELD7DAY: 'TCMnyMktAvgAnnualYield7Day',
  TCMNYMKTAVGANNUALYIELD30DAY: 'TCMnyMktAvgAnnualYield30Day',
  TCMMNYMKTEFFECTIVEYIELD7DAY: 'TCMMnyMktEffectiveYield7Day',
  TCYIELDASOFDATE: 'TCYieldAsOfDate',
  TCDISTRIBUTIONSFLAG: 'TCDistributionsFlag',
  TCISTIAACREFFUND: 'TCisTIAACREFFund',
  TCINCEPTIONDATE: 'TCInceptionDate',
  TCFUNDNAV: 'TCFundNav',
  TCFUNDNAV1DAYCHANGE: 'TCFundNav1DayChange',
  TCFUNDNAV1DAYPCTCHANGE: 'TCFundNav1DayPctChange',
  TCFUNDNAVYTDPCTCHANGE: 'TCFundNavYTDPctChange',
  TCFUNDNAVASOFDATE: 'TCFundNavAsOfDate',
  TCAVGANNRETURN1YR: 'TCAvgAnnReturn1Yr',
  TCAVGANNRETURN3YR: 'TCAvgAnnReturn3Yr',
  TCAVGANNRETURN5YR: 'TCAvgAnnReturn5Yr',
  TCAVGANNRETURN10YR: 'TCAvgAnnReturn10Yr',
  TCAVGANNRETURNSI: 'TCAvgAnnReturnSI',
  TCAVGANNRETURNSI_OFFER: 'TCAvgAnnReturnSI',
  TCAVGANNRETURNQTR1YR: 'TCAvgAnnReturnQtr1Yr',
  TCAVGANNRETURNQTR3YR: 'TCAvgAnnReturnQtr3Yr',
  TCAVGANNRETURNQTR5YR: 'TCAvgAnnReturnQtr5Yr',
  TCAVGANNRETURNQTR10YR: 'TCAvgAnnReturnQtr10Yr',
  TCAVGANNRETURNQTR3MO: 'TCAvgAnnReturnQtr3Mo',
  TCAVGANNRETURNQTRSI: 'TCAvgAnnReturnQtrSI',
  TCAVGANNUALRTRN1MO_OFFER: 'TCAvgAnnualRtrn1Mo_Offer',
  TCAVGANNUALRTRN3MO_OFFER: 'TCAvgAnnualRtrn3Mo_Offer',
  TCAVGANNUALRTRN6MO_OFFER: 'TCAvgAnnualRtrn6Mo_Offer',
  TCAVGANNUALRTRNYTD_OFFER: 'TCAvgAnnualRtrnYTD_Offer',
  TCAVGANNUALRTRN1YR_OFFER: 'TCAvgAnnualRtrn1Yr_Offer',
  TCAVGANNUALRTRN3YR_OFFER: 'TCAvgAnnualRtrn3Yr_Offer',
  TCAVGANNUALRTRN5YR_OFFER: 'TCAvgAnnualRtrn5Yr_Offer',
  TCAVGANNUALRTRN10YR_OFFER: 'TCAvgAnnualRtrn10Yr_Offer',
  TCAVGANNUALRTRNSINCEINC_OFFER: 'TCAvgAnnualRtrnSinceInc_Offer',
  TCQAVGANNUALRTRN1MO_OFFER: 'TCQAvgAnnualRtrn1Mo_Offer',
  TCQAVGANNUALRTRN3MO_OFFER: 'TCQAvgAnnualRtrn3Mo_Offer',
  TCQAVGANNUALRTRN6MO_OFFER: 'TCQAvgAnnualRtrn6Mo_Offer',
  TCQAVGANNUALRTRNYTD_OFFER: 'TCQAvgAnnualRtrnYTD_Offer',
  TCQAVGANNUALRTRN1YR_OFFER: 'TCQAvgAnnualRtrn1Yr_Offer',
  TCQAVGANNUALRTRN3YR_OFFER: 'TCQAvgAnnualRtrn3Yr_Offer',
  TCQAVGANNUALRTRN5YR_OFFER: 'TCQAvgAnnualRtrn5Yr_Offer',
  TCQAVGANNUALRTRN10YR_OFFER: 'TCQAvgAnnualRtrn10Yr_Offer',
  TCQAVGANNUALRTRNSINCEINC_OFFER: 'TCQAvgAnnualRtrnSinceInc_Offer',
  TCCURRENTRATE: 'TCCurrentRate',
  TCRATERETURNASOFDATE: 'TCRateReturnAsOfDate',
  TCRATERETURNQTRASOFDATE: 'TCRateReturnQtrAsOfDate',
  TCAVGANNRETURNASOFDATE: 'TCAvgAnnReturnAsOfDate',
  TCAVGANNRETURNQTRASOFDATE: 'TCAvgAnnReturnQtrAsOfDate',
  TCAVGANNRETURNYTD: 'TCAvgAnnReturnYTD',
  TCAVGANNRETURNQTRYTD: 'TCAvgAnnReturnQtrYTD',
  TCRATERETURN1YR: 'TCRateReturn1Yr',
  TCRATERETURN3YR: 'TCRateReturn3Yr',
  TCRATERETURN5YR: 'TCRateReturn5Yr',
  TCRATERETURN10YR: 'TCRateReturn10Yr',
  TCRATERETURNSI: 'TCRateReturnSI',
  TCRATERETURNQTR1YR: 'TCRateReturnQtr1Yr',
  TCRATERETURNQTR3YR: 'TCRateReturnQtr3Yr',
  TCRATERETURNQTR5YR: 'TCRateReturnQtr5Yr',
  TCRATERETURNQTR10YR: 'TCRateReturnQtr10Yr',
  TCRATERETURNQTRSI: 'TCRateReturnQtrSI',
  TCISEPRYTD: 'TCIsEPRYTD',
  TCISEPRY1: 'TCIsEPRY1',
  TCISEPRY3: 'TCIsEPRY3',
  TCISEPRY5: 'TCIsEPRY5',
  TCISEPRY10: 'TCIsEPRY10',
  TCMSTARRATING3YR: 'TCMstarRating3Yr',
  TCMSTARRATING5YR: 'TCMstarRating5Yr',
  TCMSTARRATING10YR: 'TCMstarRating10Yr',
  TCOVERALLRATINGOUFOFNUMBER: 'TCOverallRatingOufOfNumber',
  TCRATING3YROUTOFNUMBER: 'TCRating3YrOutOfNumber',
  TCRATING5YROUTOFNUMBER: 'TCRating5YrOutOfNumber',
  TCRATING10YROUTOFNUMBER: 'TCRating10YrOutOfNumber',
  TCMSTARCATEGORY: 'TCMstarCategory',
  TCMSTARRATINGASOFDATE: 'TCMstarRatingAsOfDate',
  TCGROSSEXPENSE: 'TCGrossExpense',
  TCGROSSEXPENSEPER1000: 'TCGrossExpensePer1000',
  TCNETEXPENSES: 'TCNetExpenses',
  TCNETEXPENSESPER1000: 'TCNetExpensesPer1000',
  TCREDEMPTIONFEE: 'TCRedemptionFee',
  TCESTANNUALEXPENSES: 'TCEstAnnualExpenses',
  TCTRANSFERLIMITTYPECODE: 'TCTransferLimitTypeCode',
  TCTRANSFERLIMITTYPENAME: 'TCTransferLimitTypeName',
  TCTRANSFERLIMITTYPEDESCRIPTION: 'TCTransferLimitTypeDescription',
  TCSYSTEMATICTRANSFEREXCLUDEIND: 'TCSystematicTransferExcludeInd',
  TCNUMBEROFDAYS: 'TCNumberOfDays',
  TCDAYSBLOCKED: 'TCDaysBlocked',
  TCSTARTDATE: 'TCStartDate',
  TCENDDATE: 'TCEndDate',
  TCPLANSERVICESEXPFEE: 'TCPlanServicesExpFee',
  TCDISTAMOUNTMONTHLY: 'TCDistAmountMonthly',
  TCDISTAMOUNTQRTLY: 'TCDistAmountQrtly',
  TCDISTNAVMONTHLY: 'TCDistNAVMonthly',
  TCDISTNAVQTRLY: 'TCDistNAVQtrly',
  TCDISTRECORDDATEMONTHLY: 'TCDistRecordDateMonthly',
  TCDISTRECORDDATEQRTLY: 'TCDistRecordDateQrtly',
  TCDISTRECORDDATEFYE: 'TCDistRecordDateFYE',
  TCDISTRECORDDATEPREVIOUSFYE: 'TCDistRecordDatePreviousFYE',
  TCDISTREINVESTPAYABLEDATEMONTHLY: 'TCDistReinvestPayableDateMonthly',
  TCDISTREINVESTPAYABLEDATEQRTLY: 'TCDistReinvestPayableDateQrtly',
  TCDISTREINVESTPAYABLEDATEFYE: 'TCDistReinvestPayableDateFYE',
  TCDISTREINVESTPAYABLEDATEPREVIOUSFYE: 'TCDistReinvestPayableDatePreviousFYE',
  TCDISTORDINCOMEFYE: 'TCDistOrdIncomeFYE',
  TCDISTORDINCOMEPREVIOUSFYE: 'TCDistOrdIncomePreviousFYE',
  TCDISTASOFDATEFYE: 'TCDistAsOfDateFYE',
  TCLONGTERMCAPGAINSFYE: 'TCLongTermcapGainsFYE',
  TCLONGTERMCAPGAINSPREVIOUSFYE: 'TCLongTermcapGainsPreviousFYE',
  TCSHORTTERMCAPGAINSFYE: 'TCShortTermCapGainsFYE',
  TCSHORTTERMCAPGAINSPREVIOUSFYE: 'TCShortTermcapGainsPreviousFYE',
  TCTOTADISTRIBUTIONFYE: 'TCTotadistributionFYE',
  TCTOTADISTRIBUTIONPREVIOUSFYE: 'TCTotadistributionPreviousFYE',
  TCPROJDISTSHORTTERMCAPGAIN: 'TCProjDistShortTermCapGain',
  TCPROJDISTLONGTERMCAPGAIN: 'TCProjDistLongTermCapGain',
  TCPROJDISTTOTALGAIN: 'TCProjDistTotalGain',
  TCPROJDISTTOTALGAINNAVPCT: 'TCProjDistTotalGainNAVPct',
  TCPROJDISTNAV: 'TCProjDistNAV',
  TCPROJDISTASOFDATE: 'TCProjDistAsOfDate',
  TCPROJDISTRECORDDATE: 'TCProjDistRecordDate',
  TCPROJDISTEXPAYREINVESTDATE: 'TCProjDistExPayReinvestDate',
  TCCONFLUENCEFUNDID: 'TCConfluenceFundID',
  TCDISTNAVANNUAL: 'TCDistNAVAnnual',
  TCCURRENTAPY: 'TCCurrentAPY',
  TCCURRENTAPR: 'TCCurrentAPR',
  TCCURRENTINTERESTRATE: 'TCCurrentInterestRate',
  TCEXPIRATIONDATE: 'TCExpirationDate',
  TCTREATASPROP: 'TCTreatAsProp',
  TCEXPENSEWAIVERCAPNOTE: 'TCExpenseWaiverCapNote',
  TCFEETYPE: 'TCFeeType',
  TCGUARANTEEDMINIMUMRATE: 'TCGuaranteedMinimumRate',
  TCSVCURRENTRATE: 'TCSVCurrentRate',
  TCSVGUARANTEEDMINIMUMRATE: 'TCSVGuaranteedMinimumRate',
  TCUNDERLYINGFUNDINCEPTIONDATE: 'TCUnderlyingFundInceptionDate',
  TCISLINKEDPERF1YR: 'TCIsLinkedPerf1Yr',
  TCISLINKEDPERF3YR: 'TCIsLinkedPerf3Yr',
  TCISLINKEDPERF5YR: 'TCIsLinkedPerf5Yr',
  TCISLINKEDPERF10YR: 'TCIsLinkedPerf10Yr',
  TCISLINKEDPERFQTR1YR: 'TCIsLinkedPerfQtr1Yr',
  TCISLINKEDPERFQTR3YR: 'TCIsLinkedPerfQtr3Yr',
  TCISLINKEDPERFQTR5YR: 'TCIsLinkedPerfQtr5Yr',
  TCISLINKEDPERFQTR10YR: 'TCIsLinkedPerfQtr10Yr',
  TCSECYIELD: 'TCSECYield',
  TCSECYIELDUNSUB: 'TCSECYieldUnsub'
};

export const MODEL_TYPES = {
  RANGE_SELECTORS: 'rangeSelectors',
  MSTAR_SELECTOR: 'mstarselectors',
  ASSET_CLASS: 'assetClassSelectors',
  PRODUCT_TYPE: 'productTypeSelectors'
};

export const MSTAR_SELECTOR_MODELS = {
  RATING: 'ratingModel'
};

export const RANGE_SELECTOR_MODELS = {
  PERFORMANCE: 'performanceModel',
  RISK: 'riskModel',
  EXPENSE: 'expenseModel',
  PERF_VS_PEERS: 'performanceVsPeersModel',
  YIELD: 'yieldModel',
  DAILY_YTD_RETURN: 'dailyYtdReturnModel',
  RISK_VS_PEERS: 'riskLevelVsPeersModel',
  INCEPTION_DATE: 'inceptionDateModel'
};

export const ASSET_CLASS_MODELS = {
  ALL: 'all',
  EQUITIES: 'equities',
  FIXEDINCOME: 'fixedIncome',
  GUARANTEED: 'guaranteed',
  MONEYMARKET: 'moneyMarket',
  MULTIASSET: 'multiAsset',
  OTHER: 'other',
  REALESTATE: 'realEstate',
  TARGETDATE: 'targetDate'
};

export const PRODUCT_TYPE_MODELS = {
  FIXEDANNUITIES: 'fixedAnnuities',
  VARIABLEANNUITIES: 'variableAnnuities',
  CREF: 'cref',
  TIAAACCESS: 'TIAAAccess',
  TIAAREALESTATE: 'TIAARealEstate',
  MUTUALFUNDS: 'mutualFunds',
  RETIREPLUSMODELS: 'retirePlusModels',
  RETIREPROPLUSMODELS: 'retirePlusProModels',
  FDICINSUREDPRODUCTS: 'FDICInsuredProducts',
  OTHER: 'other'
};

export const PRODUCT_TYPE_TO_MODEL = {
  'Fixed Annuities': PRODUCT_TYPE_MODELS.FIXEDANNUITIES,
  'Variable Annuities': PRODUCT_TYPE_MODELS.VARIABLEANNUITIES,
  'CREF Variable Annuity': PRODUCT_TYPE_MODELS.CREF,
  'TIAA Access Variable Annuity': PRODUCT_TYPE_MODELS.TIAAACCESS,
  'Mutual Funds': PRODUCT_TYPE_MODELS.MUTUALFUNDS,
  'RetirePlus Models': PRODUCT_TYPE_MODELS.RETIREPLUSMODELS,
  'RetirePlus Select Models': PRODUCT_TYPE_MODELS.RETIREPLUSMODELS,
  'Custom Portfolio Models': PRODUCT_TYPE_MODELS.RETIREPROPLUSMODELS,
  'FDIC Insured Products': PRODUCT_TYPE_MODELS.FDICINSUREDPRODUCTS,
  'TIAA Real Estate': PRODUCT_TYPE_MODELS.TIAAREALESTATE,
  'Other Investments': PRODUCT_TYPE_MODELS.OTHER
};

// actual screener values mapped to model keys
export const ASSET_CLASS_TO_MODEL = {
  Equities: ASSET_CLASS_MODELS.EQUITIES,
  'Fixed Income': ASSET_CLASS_MODELS.FIXEDINCOME,
  Guaranteed: ASSET_CLASS_MODELS.GUARANTEED,
  'Money Market': ASSET_CLASS_MODELS.MONEYMARKET,
  'Multi-Asset': ASSET_CLASS_MODELS.MULTIASSET,
  Other: ASSET_CLASS_MODELS.OTHER,
  'Real Estate': ASSET_CLASS_MODELS.REALESTATE,
  'Target Date': ASSET_CLASS_MODELS.TARGETDATE
};

export const FILTER_TYPE = {
  PRODUCTTYPE: 'productType',
  ASSETCLASS: 'assetClass'
};

export const STYLE_BOX_MODELS = {
  EQUITIES: 'equitiesModel',
  BONDS: 'bondsModel'
};

export const CHANNELS = {
  DYNAMICMICROSITES: 'microsites',
  MYTIAA: 'mytiaa',
  PUBLIC: 'public',
  SLAM: 'slam'
};

export const PAGES = {
  SCREENER: 'screener',
  DISTRIBUTIONS: 'distributions'
};

export const ARGSOP = {
  AND: 'AND',
  OR: 'OR'
};

export const SHARE_CLASS = {
  ALL: 'All',
  LEVEL1: 'Level 1',
  LEVEL2: 'Level 2',
  LEVEL3: 'Level 3',
  LEVEL4: 'Level 4',
  CLASSR1: 'Class R1',
  CLASSR2: 'Class R2',
  CLASSR3: 'Class R3',
  CLASSR4: 'Class R4',
  CLASSR6: 'Class R6',
  PREMIER: 'Premier Class',
  RETIREMENT: 'Retirement Class',
  CLASSA: 'Class A',
  CLASSI: 'Class I',
  CLASSW: 'Class W'
};

export const ASSET_CLASS = {
  FIXEDINCOME: 'Fixed Income',
  EQUITIES: 'Equities',
  GUARANTEED: 'Guaranteed',
  MONEYMARKET: 'Money Market',
  MULTIASSET: 'Multi-Asset',
  OTHER: 'Other',
  REALESTATE: 'Real Estate',
  TARGETDATE: 'Target Date'
};

export const FOOTNOTE_DISCLAIMERS = {
  TIAATRADITIONALALWAYS: 'TIAATraditionalAlways',
  TIAATRADITIONALCURRENTRATES: 'TIAATraditionalCurrentRates',
  CREFVARIABLEANNUITYALWAYS: 'CREFVariableAnnuityAlways',
  CREFVARIABLEANNUITYMONEYMARKET: 'CREFVariableAnnuityMoneyMarket',
  CREFVARIABLEANNUITY30DAYSECYIELD: 'CREFVariableAnnuity30DaySECYield',
  TIAAACCESSVARIABLEANNUITYALWAYS: 'TIAAAccessVariableAnnuityAlways',
  TIAAACCESSVARIABLEANNUITYMONEYMARKET: 'TIAAAccessVariableAnnuityMoneyMarket',
  TIAAACCESSVARIABLEANNUITYMONEYMARKET30DAYSECYIELD: 'TIAAAccessVariableAnnuityMoneyMarket30DaySECYield',
  TIAASTABLEVALUEALWAYS: 'TIAAStableValueAlways',
  RETIREPLUSMODELSALWAYS: 'RetirePlusModelsAlways',
  CUSTOMPORTFOLIOMODELSALWAYS: 'customPortfolioModelsAlways',
  MUTUALFUNDMONEYMAKETPROP: 'mutualFundMoneyMaketProp',
  MUTUALFUNDMONEYMAKETNONPROP: 'mutualFundMoneyMaketNonProp',
  MUTUALFUNDNAV: 'mutualFundNav',
  MUTUALFUND30DAYSECYIELD: 'mutualFund30DaySECYield',
  MUTUALFUND7DAYCURRENTEFFECTIVEYIELD: 'mutualFund7DayCurrentEffectiveYield',
  FDICPRODUCTANNUALPERCENTAGEYIELD: 'FDICProductAnnualPercentageYield',
  FDICPRODUCTCURRENTINTERESTRATE: 'FDICProductCurrentInterestRate',
  AVGANNUALNONTIAATRADITIONAL: 'avgAnnualNonTIAATraditional',
  AVGANNUALTIAATRADITIONAL: 'avgAnnualTIAATraditional',
  ASSETCLASSGUARENTEEDTIAATRADITIONAL: 'AssetClassGuarenteedTIAATraditional',
  ASSETCLASSGUARENTEEDNONTRADITIONAL: 'AssetClassGuarenteedNonTraditional',
  DEFAULTABOVENUMBERED: 'defaultAboveNumbered',
  DEFAULTBELOWNUMBERED: 'defaultBelowNumbered',
  MSTARNUMBERED: 'MStarNumbered',
  DEFAULTNONCOLLAPSIBLE: 'defaultNoncollapsible',
  TIAASTABLEVALUENUMBERED: 'TIAAStableValueNumbered',
  HYPOTHETICALPERFORMANCE: 'HypotheticalPerformance',
  HYPOTHETICALCHART: 'hypotheticalChart'
};

export const FOOTNOTE_DISCLAIMERS_NUMBERS = {
  PRODUCTTYPEDISNUM: 'productTypeNumbered',
  AVEANNUALDISNUM: 'aveAnnualNumbered',
  ASSETCLASSDISNUM: 'assetClassNumbered',
  CURRENTRATEDISNUM: 'currentRateNumbered',
  SECYEILDDISNUM: 'secYieldNumbered',
  MSTARDISNUM: 'mstarNumbered',
  NAVDISNUM: 'navNumbered',
  CURRENTEFFECTIVEYIELDDISNUM: 'currentEffectiveYieldNumbered',
  APYDISNUM: 'apyNumbered',
  CURRENTINTERESTRATEDISNUM: 'interestRateNumbered',
  HYPOTHETICALCHARTISNUM: 'hypochartNumbered'
};

export const DEFAULT_VIEWS = {
  NONE: 'none',
  FAONLY: 'faonly',
  VAONLY: 'vaonly',
  ACCESSONLY: 'accessonly',
  MFONLY: 'mfonly',
  MFCLASSR6: 'mfclassr6',
  MFRETAILONLY: 'mfretailonly',
  MFCLASSI: 'mfclassi',
  MFCLASSPREMIER: 'mfclasspremier',
  MFCLASSRETIREMENT: 'mfclassretirement',
  MFCLASSW: 'mfclassw'
};

export const CREDIT_RATING_MODELS = {
  SP: 'S&PModel',
  MOODY: 'moodyModel',
  AMBEST: 'AMbestModel',
  FITCH: 'fitchModel'
};

export const PRODUCT_TYPE = {
  FIXEDANNUITIES: 'Fixed Annuities',
  VARIABLEANNUITIES: 'Variable Annuities',
  CREF: 'CREF Variable Annuity',
  TIAAACCESS: 'TIAA Access Variable Annuity',
  TIAAREALESTATE: 'TIAA Real Estate',
  MUTUALFUNDS: 'Mutual Funds',
  RETIREPLUSMODELS: 'RetirePlus Models',
  RETIREPROPLUSMODELS: 'Custom Portfolio Models',
  FDICINSUREDPRODUCTS: 'FDIC Insured Products',
  OTHER: 'Other Investments'
};


const screenerConstants = {
  OPERATORS,
  FIELDS,
  RANGE_SELECTOR_MODELS,
  MSTAR_SELECTOR_MODELS,
  ASSET_CLASS_MODELS,
  PRODUCT_TYPE_MODELS,
  FILTER_TYPE,
  STYLE_BOX_MODELS,
  CHANNELS,
  ARGSOP,
  FOOTNOTE_DISCLAIMERS,
  CREDIT_RATING_MODELS,
  PRODUCT_TYPE
};

export default screenerConstants;
